
<section>
    <app-static-header></app-static-header>
</section>
<section>
    <div class="banner_content_slider">
        <div id="carouselExampleControls" class="carousel slide">
            <div class="carousel-inner carousel-bg">
              <div class="carousel-item active" routerLink="/admissions">
                <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/kidzee_banner/home_header.png" class="d-block img-fluid slider_banner" alt="...">
               <div class="banner_title_content">
                <div class="banner_title">Build a foundation
                    for<br>a life time of <br>
                    learning
                </div>
               </div>
               <div class="admission_open" routerLink="/admissions">
                Admission Open
            </div>
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/enroll_now.png" class="enroll_now_img" alt="" routerLink="/admissions">
                <!-- <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/home_page_girl.png" class="home_girl_img" alt=""> -->
              </div>
              <div class="carousel-item" routerLink="/partner-with-kidzee">
                <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/kidzee_banner/banner_4.png" class="d-block img-fluid slider_banner" alt="...">
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/enroll_now.png" class="enroll_now_img1" alt="" routerLink="/partner-with-kidzee"> 
            </div>
            
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
          
    </div>
    <div class="mobile_res">
        <div id="carouselExampleControls1" class="carousel slide">
            <div class="carousel-inner carousel-bg">
              <div class="carousel-item active" routerLink="/admissions">
                <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/kidzee_banner/mobile_home_banner.png" class="d-block img-fluid slider_banner" alt="...">
               <div class="banner_title_content">
                <div class="banner_title">Build a foundation
                    for<br>a life time of <br>
                    learning
                </div>
               </div>
               <div class="admission_open" routerLink="/admissions">
                Admission Open
            </div>
            <div class="d-flex justify-content-center">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/enroll_now.png" class="enroll_now_img" alt="" routerLink="/admissions">
        </div>
              </div>

              <div class="carousel-item" routerLink="/partner-with-kidzee">
                <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/kidzee_banner/banner_4_mobileRes.png" class="d-block img-fluid slider_banner" alt="...">
               <!-- <div class="banner_title_content">
                <div class="banner_title">Build a foundation
                    for<br>a life time of <br>
                    learning
                </div>
               </div>
               <div class="admission_open">
                Admission Open
            </div> -->
            <div class="d-flex justify-content-center">
            <!-- <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/enroll_now.png" class="enroll_now_img" alt=""> -->
        </div>
              </div>
             
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls1" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls1" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
          
    </div>

</section>
<section>
    <div class="mainDiv">
        <app-home-about-us></app-home-about-us>
    </div>
</section>
<section>
<app-programmes></app-programmes>
</section>
<section>
    <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/day_care_bg_img.png" class="day_care_bg" alt="">
    <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/thumbnail_day_care_mobile_res_bg.png" class="day_care_bg_mobile" alt="">
    <div class="mainDiv2">
        <div class="dayCareContent">
            <div class="row">
                <div class="col-md-6">
                    <div class="dayCareText">
                        <div class="right_content1">
                            <h1 class="title day_care_color">
                                DayCare
                            </h1>
                            <div class="subTitle white_color">
                                Kidzee Daycare -<br> A home away from home for your child !
                            </div>
                        <div class="infoContent mt-3">
                            <div class="text1">
                                <div class="sub_text">Duration - Choose suitable hours schedule.
                                </div>
                                <div class="sub_text mt-1">Flexible hours - Post school schedule.
                                </div>
                            </div>
                        </div>
                            <div class="paragraph_content mt-4 white_color">
                                <p>We understand that the early years in the child’s life are important for the overall development. The primary role of parents in these years is to provide their children with an environment that is  loving, caring, fun-filled and one which provides happy experiences. As these aspects play a very important role in fostering the developmental areas, like, cognitive development, physical development, socio-emotional development, and so on our objective is to create a home away from home for them to feel safe, secure and happy.</p>
                            </div>
                        </div>
                        <div class="know_more">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/know_more.png" routerLink="/daycare" alt="">
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="dayCardImg">
                        <div class="">
                            <img srcset="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/day_care_chaild.png" loading="lazy" alt="Kidzee Daycare" class="schoolGirlImg responsive"
                                align="center">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section>
   
    <div class="mainDiv3">
     <h1 class="title">Our Pedagogy</h1>
        <img srcset="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/baloon.png" class="baloon_img_content" alt="">
        <img srcset="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/more_fish.png" class="more_fish_content" alt="">
        <div class="pentemindGroup">
            <div class="d-flex justify-content-center">
                <img src="https://s3.ap-south-1.amazonaws.com/content.pentemind.com/kidzee/pantamind_new_img.svg" loading="lazy" class="pentemindgroupImg responsive" align="center" alt="pentemind">
            </div>
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bird.png" class="bird_img_content" alt="">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/circal.png" class="circal_img_content" alt="">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/right_circal.png" class="right_circal_img_content" alt="">
        </div>
        <div class="pentamind_content text-center">
            <h6 class="text-center"><b>Péntemind - The Learning Minds</b>, our pedagogy nurtures the ‘Learning Minds’ in every child. It shapes the child’s overall development in a fun and <b>inspiring manner</b>.</h6>
        </div>
        <div class="pentemind_content d-flex justify-content-center mt-2">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/know_more.png" routerLink="/pentemind" alt="">
        </div>
    </div>
</section>
<section>
    <div class="mainDiv4">
        <app-kidzee-pree-school></app-kidzee-pree-school>
    </div>
</section>
<section>
    <div class="mainDiv21">
        <div class="dayCareContent1">
            <div class="row flex-column-reverse flex-lg-row">
                <!-- <div class="col-md-6">
                    <div class="dayCardImg">
                        <div class="">
                            <img srcset="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/childGroup.png" loading="lazy" alt="" class="franchiseImg responsive"
                                align="center" alt="Franchise Opportunity">
                        </div>
                    </div>
                </div> -->
                <div class="col-md-12">
                    <div class="dayCareText">
                        <div class="right_content1">
                            <h1 class="title text-center">
                               <span style="color:#6D2A93;"> Franchise</span> <span class="white_color mx-2">Opportunity</span>
                            </h1>
                            <div class="subTitle text-center">
                                Start your own Preschool, today!
                            </div>
                            <div class="paragraph_content mt-3">
                                <p class="text-center count_color">2,000+ CENTRES | 750+ CITIES</p>
                                <div class="row para_text">
                                    <div class="col-md-2 border_left">
                                        <p>India's largest preschool chain</p>
                                    </div>
                                    <div class="col-md-3 border_left">
                                        <p>Market leader with a strong brand recall & brand lineage of 20+ years</p>
                                    </div>
                                    <div class="col-md-2 border_left">
                                        <p>Proven business model</p>
                                    </div>
                                    <div class="col-md-2 border_left">
                                        <p>Best-in class pedagogy</p>
                                    </div>
                                    <div class="col-md-3" style="color: #6D2A93;">
                                        <p>Comprehensive support including operational, academic, training, and project support</p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="pentemind_content d-flex justify-content-center pt_know_more">
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/know_more_color.png" routerLink="/partner-with-kidzee" alt="">
                            </div> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
<section>
    <div class="mainDiv5">
        <app-faqs ></app-faqs>
    </div>
</section>
<section>
    <div class="mainDiv6">
        <div class="blogsContent">
            <app-blogs></app-blogs>
        </div>
    </div>
</section>
<app-slider-parents></app-slider-parents>
<app-footer></app-footer>
